import { Spacer } from '@zillow/constellation';
import { useWizard, useWizardStep } from '@zillow/zrs-rental-applications';
import React from 'react';
import DefaultBackLink from '../../../components/BackLink';
import { getLandlordReviewPath } from '../../../constants/urls';
import useQueryVariables from '../../../hooks/useQueryVariables';

const OverviewLink = () => {
  const { applicationId, propertyId } = useQueryVariables();
  const { currentStep } = useWizard();
  const { meta: { hideOverviewLink = false } = {} } = useWizardStep({
    id: currentStep,
    subscription: ['hideOverviewLink'],
  });

  if (hideOverviewLink) {
    return <Spacer marginTop="lg" marginBottom="lg" />;
  }

  return (
    <DefaultBackLink to={getLandlordReviewPath(propertyId, applicationId)} data-test="overview-link">
      Application overview
    </DefaultBackLink>
  );
};

export default OverviewLink;
